import { Box, Grid, Typography } from "@mui/material";
import News from "./News";
import news1 from '../assets/images/news/Vidusaviya - donation.jpg';
import news2 from '../assets/images/news/UWU EXPO 2025.jpg';
import news3 from '../assets/images/news/Stamp - UWU 20th.jpg';
function NewsBar() {
    const news = [
        {
            title: "\"Vidusaviya\" – Empowering Education Through Technology",
            time: "08 Aug 2025 | 7:30AM",
            image: news1,
            des: `Phase 01 – Computer Donation to Tholabowatta College, Passara 26th July 2025

The UWU Alumni Association proudly launched its newest education-focused initiative, “Vidusaviya”, with the mission of bridging the digital divide in underprivileged schools across rural Sri Lanka. The program aims to donate computers to schools in need, empowering students through access to technology and digital learning resources.
The first phase of this meaningful initiative was successfully held on 26th July 2025 at Tholabowatta College in Passara, where a set of computers was donated to enhance the school’s ICT learning environment. This marks a significant step in enabling equal learning opportunities for students in remote areas and preparing them for the future.
The “Vidu Saviya” program reflects the Alumni Association’s continued commitment to giving back to society, especially in the field of education. By strengthening digital literacy and supporting under-resourced schools, the initiative strives to uplift communities and create lasting impact in the lives of young learners.
This is only the beginning. More phases are planned in the near future to extend support to other deserving schools across the island. 
Together, let’s power up young minds through knowledge and technology
`,
            link: "https://www.facebook.com/uwualumni/posts/pfbid07cPbKHB6LVc73cEAcrjo6pqi4jVXKAqBqz1zpFMvcMbTBrD63TLibYWmVVGTXevjl"
        },
        {
            title: "UWU EXPO 2025 – A Grand Celebration of 20 Years of Excellence",
            time: "08 Aug 2025 | 7:30AM",
            image: news2,
            des: `Held on 16-19 July 2025 | Uva Wellassa University Premises
            
The Uva Wellassa University came alive from 16th to 19th July 2025, proudly hosting UWU EXPO 2025, the signature event commemorating the University’s 20th Anniversary. Organized under the theme “Celebrating 20 Years of Excellence”, the event marked a significant milestone in UWU’s journey, showcasing its evolution over two decades of innovation, entrepreneurship, and collaboration.
The EXPO featured a dynamic series of events, including cutting-edge academic and industrial exhibitions, expert panel discussions, cultural performances, and student-led entrepreneurial showcases. The entire campus transformed into a vibrant arena of knowledge-sharing and celebration, reflecting the diverse talents and pioneering spirit that have defined UWU since its inception.
The UWU Alumni Association was proud to play an active role in this momentous celebration, strengthening ties between past graduates and the current UWU community. Alumni from various fields and graduating batches returned to their alma mater, reuniting with faculty and contributing to meaningful discussions on the future of education and industry. A notable highlight was the commemorative stamp launching an initiative proudly led by the Alumni Association in honor of the 20th anniversary. 
UWU EXPO 2025 was more than just a celebration it was a powerful reflection of the University’s transformative journey, the achievements of its graduates, and the collective commitment to excellence that continues to inspire generations. 
Here’s to 20 incredible years, and to shaping an even brighter future together!
`,
            link: "https://www.facebook.com/media/set/?set=a.1302449071881123&type=3"
        },
        {
            title: "UWU Alumni Association Sponsors Commemorative Stamp for 20th Anniversary Celebration",
            time: "08 Aug 2025 | 7:30AM",
            image: news3,
            des: `In honor of Uva Wellassa University’s remarkable journey over the past two decades, the UWU Alumni Association proudly sponsored a commemorative postal stamp as part of the UWU 20th Anniversary celebrations.
This symbolic initiative marks a significant milestone in the University’s history, capturing the spirit of innovation, excellence, and unity that has defined UWU since its inception. The official stamp was unveiled during UWU EXPO 2025, held from 16th to 19th July, amidst a series of celebratory events.
As proud ambassadors of the University, the Alumni Association is delighted to have played a leading role in preserving UWU’s legacy through this historic gesture. The commemorative stamp not only reflects UWU’s journey but also celebrates the enduring connection between the University and its alumni across the globe.
`
            , link: "https://www.facebook.com/uwualumni/posts/pfbid02V11tWN4hBTzmvzU8v4PKBLcy4nCiMYqtPeSfZMR7v8Z6SyPMxaLakikHQXHbP4Gel"
        }
    ]

    return (
        <Box sx={{
            width: '100%',
            justifyContent: 'center',
            display: 'flex',
            marginTop: '50px',
            marginBottom: '100px'
        }}>

            <Box sx={{
                width: '85%'
            }}>
                <Typography align={'justify'} width={'100%'} variant={'h3'} fontWeight={'600'}
                    sx={{
                        color: '#091D3D'
                    }}>Recent News
                </Typography>

                <Grid container spacing={3} sx={{
                    marginTop: '50px',
                }}>
                    {
                        news.map((item, index) => (
                            <Grid item md={4}>
                                <News link={item.link} time={item.time} image={item.image} des={item.des} title={item.title} />
                            </Grid>
                        ))
                    }

                </Grid>

            </Box>

        </Box>
    )
}
export default NewsBar